import React, { useState, useEffect } from 'react'
import axiosService from "../../utils/axios.service";
import _ from 'lodash';
import { PackageStatus } from './constant/CustomerBirthday';
import { format } from "date-fns"
import { Select, Spin } from 'antd';
import "./scss/packagepopup.scss";

export function PackagePopup(props) {
    const [orderUsed, setOrderUsed] = useState([])
    const [childPackage, setChildPackage] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState(props.customer.id)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getAllOrder()
    }, [props.package, selectedCustomer])

    useEffect(async () => {
        let response = await axiosService("api/package/package-family/" + props.package.id, "GET");
        if (response.data.code == 200) {
            let listFamily = []
            let listAll = [{value: 0, label: "Tất cả"}]
            response.data.data.map((item, index) => {
                if (!item.family_delete) listFamily.push(item)
                listAll.push({value: item.id, label: `${item.full_name} - ${item.mobile}`})
            })
            props.setListFamily(listFamily)
            props.setAllFamily(listAll)
        }
    }, [props.package])

    const getAllOrder = async () => {
        setLoading(true)
        let payload = {
            package_id: props.package.id,
            customer_id: (selectedCustomer == 0) ? null : selectedCustomer
        }
        let response = await axiosService("api/package/history-item", "POST", payload)

        if (response.data.code == 200) {
            setOrderUsed(response.data.data.listOrder)
            setChildPackage(response.data.data.statusChild)
        }
        setLoading(false)
    }

    const getDetailOrder = async (id)  => {
        let response = await axiosService("api/package/order-use/" + id, "GET");
        if (response.data.code == 200) props.showPopupOrder(response.data.data)
    }

    return (
        <Spin spinning={loading} size="large" tip="Đang tải...">
            <div className="head-popup">
                <div className="title">Lịch sử sử dụng thẻ</div>
            </div>
            <div className="body-popup">
                <div className="panel panel-flat">
                    <div className="panel-body">
                        <div className="row mt-10 show-head">
                            <div className="col-md-4 customer-info">
                                <div className="row">
                                    <label className="control-label col-5 pr-10">Khách hàng</label>
                                    <label className="control-label col-7 customer-name">
                                        {props?.customer?.full_name ?? props.package.customer_name}
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-5 pr-10">Điện thoại</label>
                                    <label className="control-label col-7">{props?.customer?.mobile ?? props.package.customer_mobile}</label>
                                </div>
                                {props.package.product.number_family > 0 ?
                                    <div className="row">
                                        <label onClick={() => {props.setFamilyPopup(true)}} className="control-label col-12 pr-10 label-customer-family">Khách đồng sở hữu</label>
                                    </div>
                                :null}
                            </div>
                            <div className="col-md-4 package-info-name">
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">
                                        <span className="package-order">{props.package.product ? props.package.product.product_name : props.package.product_name}</span>
                                    </label>
                                    <label className="control-label col-5">
                                        <span className="tag bg-green" >{props.package.type}</span>
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Mã thẻ</label>
                                    <label className="control-label col-5 text-bold text-uppercase">{props.package.package_code}</label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Tình trạng</label>
                                    <label className="control-label col-5">
                                        <span className="tag no-margin bg-info">{PackageStatus[props.package.status]}</span>
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Ghi chú</label>
                                    <label className="control-label col-5 text-bold">{props.package.note ? props.package.note : '--'}</label>
                                </div>
                            </div>
                            <div className="col-md-4 package-info-date">
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Số lần đã sử dụng:</label>
                                    <label className="control-label col-5">
                                        <span className="font-20 text-bold">{props.package.count_used}</span>
                                        <span className="ng-scope">
                                            <span className="ng-scope">/ {props.package.max_used > 1000 ? "Không giới hạn" : props.package.max_used}</span>
                                        </span>
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Ngày cấp</label>
                                    <label className="control-label col-5 text-green text-bold">
                                        <span className="ng-scope">{format(new Date(props.package.date_of_issue), "dd-MM-yyy HH:mm")}</span>
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Ngày hết hạn</label>
                                    <label className="control-label col-5 text-danger text-bold">
                                        <span className="ng-scope">{format(new Date(props.package.expiration_date), "dd-MM-yyy HH:mm")}</span>
                                    </label>
                                </div>
                                <div className="row ng-scope">
                                    <label className="control-label col-7 text-right pr-10">Hoá đơn cấp thẻ</label>
                                    <label className="control-label col-5 text-danger text-bold">
                                        <p ng-click="showOrderInfo(merberCard.order_id)" className="ng-binding">{props.package.order_code}</p>
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="control-label col-7 text-right pr-10">Tại chi nhánh</label>
                                    <label className="control-label col-5 text-danger text-bold">
                                        <span className="ng-scope">{props.package?.store?.name_store}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {props.allFamily.length > 2 ? 
                    <Select className="select" onChange={(e) => {setSelectedCustomer(e)}} defaultValue={selectedCustomer} options={props.allFamily} style={{ width: 350, marginBottom: "10px" }} />
                :null}
                
                <div className="fixed-content-wrapper customer-list-container">
                    <div className="panel panel-flat max-height">
                        <div className="report-summary-block bg-blue commission-summary">
                            Số lần đã sử dụng: {props.package.count_used}
                        </div>
                        <table className="table table-history-package">
                            <thead>
                                <tr>
                                    <th className="label-order">Hoá đơn</th>
                                    <th className="label-name">Tên thẻ</th>
                                    <th className="label-count">Sử dụng</th>
                                    <th className="label-note">Ghi chú</th>
                                    <th className="label-store">Cơ sở</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderUsed.length > 0 ?
                                    orderUsed.map((item, key) => (
                                        item.orderItem.length > 0 ? 
                                            <tr key={key}>
                                                <td><p className="order-code" onClick={() => getDetailOrder(item.id)}>{item.order_code}</p> {format(new Date(item.order_at), "dd-MM-yyy HH:mm")}</td>
                                                <td className="multi-item">
                                                    {childPackage ? 
                                                        item.orderItem.map((item2, key2) => (
                                                            <p key={key2}>{key2+1}. {item2.product_name}</p>
                                                        ))
                                                    : 
                                                        <p>{item.orderItem[0].product_name}</p>
                                                    }
                                                </td>
                                                {childPackage ?
                                                    <td>{props.package.package_type_using === 1 ? item.orderItem.length : 1}</td>
                                                :
                                                    <td>{item.orderItem.length}</td>
                                                }
                                                
                                                <td>{item.description}</td>
                                                <td>{item.stores.name_store}</td>
                                            </tr>
                                        : null))
                                : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="bottom-popup">
                <div className="button-container">
                    <div onClick={() => {props.setShowHistory(false)}} className="button-cent style3">
                        <span><i className="fas fa-times"></i></span>Đóng
                    </div>
                </div>
            </div>
        </Spin>
    )
}
